/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (max-width:599px){.payment-methods__list[_ngcontent-%COMP%]{-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-line-pack:center;align-content:center;text-align:center;-ms-flex-pack:center;justify-content:center}.payment-methods__item[_ngcontent-%COMP%]{margin:1rem}}.payment-notifications__wrapper[_ngcontent-%COMP%]{margin-bottom:2rem}@media (max-width:599px){.payment-notifications__wrapper[_ngcontent-%COMP%]{margin-bottom:0}}.payment-notifications__wrapper[_ngcontent-%COMP%]   app-notification[_ngcontent-%COMP%]{display:block;margin:.5rem 0}"];
export { styles as styles };
